/* assets/masha-search.js
   MASHA USA - Luxury Search Pane + Predictive Suggestions + Trending + Keyboard Nav
*/

(function () {
  const pane = document.getElementById("masha-search-pane");
  const input = document.getElementById("masha-search-input");
  const results = document.getElementById("masha-search-results");
  if (!pane || !input || !results) return;

  const closeEls = pane.querySelectorAll("[data-masha-close]");
  const goBtn = pane.querySelector("[data-masha-go]");

  // =========================
  // SETTINGS
  // =========================
  const TRENDING_COLLECTION_HANDLE = "trending"; // change to your handle if needed
  const TRENDING_COUNT = 9;

  // =========================
  // STATE
  // =========================
  let debounceTimer = null;
  let trendingCache = null;

  // Keyboard navigation state
  let navItems = []; // array of <a> nodes
  let navIndex = -1; // -1 means none selected

  // =========================
  // THEME OVERLAY KILLER
  // =========================
  function forceCloseThemeSearch() {
    // Close any <details> based search toggles (common in Shopify themes)
    document.querySelectorAll("details[open]").forEach((d) => {
      const isSearch =
        d.querySelector('input[type="search"]') ||
        ((d.id || "").toLowerCase().includes("search"));
      if (isSearch) d.removeAttribute("open");
    });

    // Remove common “modal open” classes that apply dimming/fades
    document.body.classList.remove(
      "overflow-hidden",
      "modal-open",
      "drawer-open",
      "search-open",
      "menu-open"
    );

    document.documentElement.classList.remove(
      "overflow-hidden",
      "modal-open",
      "drawer-open",
      "search-open",
      "menu-open"
    );

    // Hard-hide common overlay elements if theme left them behind
    [
      ".search-modal",
      ".search-modal__overlay",
      ".modal-overlay",
      ".drawer__overlay",
      ".predictive-search__overlay",
      ".modal__overlay",
      ".overlay",
      "[class*='overlay']"
    ].forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => {
        if (el.closest && el.closest("#masha-search-pane")) return;
        el.style.display = "none";
        el.style.opacity = "0";
        el.style.pointerEvents = "none";
      });
    });
  }

  // =========================
  // NAV ITEMS / KEYBOARD HELPERS
  // =========================
  function clearKbActive() {
    navItems.forEach((el) => el.classList.remove("masha-kb-active"));
  }

  function refreshNavItems() {
    // Only links inside results should be navigable
    navItems = Array.from(results.querySelectorAll("a.masha-suggestion, a.masha-product"));
    navIndex = -1;
    clearKbActive();
  }

  function setActiveIndex(i) {
    if (!navItems.length) {
      navIndex = -1;
      return;
    }

    // wrap
    if (i < 0) i = navItems.length - 1;
    if (i >= navItems.length) i = 0;

    clearKbActive();
    navIndex = i;

    const el = navItems[navIndex];
    el.classList.add("masha-kb-active");

    // keep it visible in the scroll container
    el.scrollIntoView({ block: "nearest" });
  }

  function openActiveOrSearch() {
    // If keyboard selection exists, open it
    if (navIndex >= 0 && navItems[navIndex]) {
      window.location.href = navItems[navIndex].href;
      return;
    }
    // Otherwise go to standard search
    goSearch();
  }

  // =========================
  // OPEN / CLOSE (fresh mode)
  // =========================
  function openPaneFresh() {
    forceCloseThemeSearch();

    pane.setAttribute("aria-hidden", "false");
    document.body.classList.add("masha-search-open");
    document.documentElement.style.overflow = "hidden";

    clearTimeout(debounceTimer);
    input.value = "";
    renderTrending(); // Trending before typing

    setTimeout(() => input.focus(), 20);
  }

  function closePane() {
    pane.setAttribute("aria-hidden", "true");
    document.body.classList.remove("masha-search-open");
    document.documentElement.style.overflow = "";

    clearTimeout(debounceTimer);
    input.value = "";
    results.innerHTML = "";
    refreshNavItems();
  }

  // Close buttons / backdrop
  closeEls.forEach((el) => el.addEventListener("click", closePane));

  // Reliable "click outside closes"
  document.addEventListener(
    "click",
    (event) => {
      if (pane.getAttribute("aria-hidden") === "true") return;
      const innerPanel = pane.querySelector(".masha-search-pane__inner");
      if (!innerPanel) return;
      if (!innerPanel.contains(event.target)) closePane();
    },
    true
  );

  // ESC closes
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && pane.getAttribute("aria-hidden") === "false") {
      closePane();
    }
  });

  // =========================
  // GO SEARCH
  // =========================
  function goSearch() {
    const q = input.value.trim();
    if (!q) return;
    window.location.href = `/search?q=${encodeURIComponent(q)}`;
  }

  if (goBtn) goBtn.addEventListener("click", () => openActiveOrSearch());

  // =========================
  // TRIGGERS
  // =========================
  const triggers = document.querySelectorAll(
    [
      'a[href="/search"]',
      'a[href^="/search"]',
      'button[aria-label*="Search"]',
      'button[title*="Search"]',
      'summary[aria-label*="Search"]',
      ".header__icon--search",
      ".search-toggle",
      ".js-search-toggle"
    ].join(",")
  );

  triggers.forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      openPaneFresh();
    });
  });

  // =========================
  // HELPERS
  // =========================
  function moneyFromCents(cents) {
    if (typeof cents !== "number") return "";
    return `$${(cents / 100).toFixed(2)}`;
  }

  function safeImg(p) {
    if (p?.featured_image?.url) return p.featured_image.url;
    if (typeof p?.featured_image === "string") return p.featured_image;
    if (p?.images && p.images.length && typeof p.images[0]?.src === "string") return p.images[0].src;
    return "";
  }

  function shuffle(arr) {
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  // =========================
  // TRENDING
  // =========================
  async function fetchTrendingProducts() {
    try {
      const colUrl = `/collections/${encodeURIComponent(TRENDING_COLLECTION_HANDLE)}/products.json?limit=50`;
      const res = await fetch(colUrl, { headers: { Accept: "application/json" } });
      if (res.ok) {
        const data = await res.json();
        const products = data?.products || [];
        if (products.length) return products;
      }
    } catch (_) {}

    try {
      const res = await fetch(`/products.json?limit=50`, { headers: { Accept: "application/json" } });
      const data = await res.json();
      return data?.products || [];
    } catch (_) {}

    return [];
  }

  async function renderTrending() {
    results.innerHTML = `<div class="masha-search-hint">Loading trending pieces…</div>`;
    refreshNavItems();

    if (!trendingCache) trendingCache = await fetchTrendingProducts();

    const pool = Array.isArray(trendingCache) ? trendingCache : [];
    const picked = shuffle(pool).slice(0, TRENDING_COUNT);

    if (!picked.length) {
      results.innerHTML = `<div class="masha-search-hint">Start typing to see suggestions and matching products.</div>`;
      refreshNavItems();
      return;
    }

    results.innerHTML = `
      <div class="masha-products" style="grid-column: 1 / -1;">
        <div class="masha-products__title">Trending</div>
        <div class="masha-products__grid">
          ${picked
            .map((p) => {
              const url = p?.handle ? `/products/${p.handle}` : (p?.url || "#");
              const title = p?.title || "";
              const price =
                (p?.variants && p.variants[0]?.price)
                  ? `$${Number(p.variants[0].price).toFixed(2)}`
                  : (typeof p?.price === "number" ? moneyFromCents(p.price) : "");

              const img = safeImg(p);

              return `
                <a class="masha-product" href="${url}">
                  <div class="masha-product__img">
                    ${img ? `<img src="${img}" alt="${title.replace(/"/g, "&quot;")}" loading="lazy">` : ""}
                  </div>
                  <div class="masha-product__body">
                    <div class="masha-product__title">${title}</div>
                    <div class="masha-product__price">${price}</div>
                  </div>
                </a>
              `;
            })
            .join("")}
        </div>
      </div>
    `;

    refreshNavItems();
  }

  // =========================
  // LIVE SEARCH + KEYBOARD NAV
  // =========================
  input.addEventListener("keydown", (e) => {
    // If pane closed, ignore
    if (pane.getAttribute("aria-hidden") === "true") return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      if (!navItems.length) refreshNavItems();
      setActiveIndex(navIndex === -1 ? 0 : navIndex + 1);
      return;
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      if (!navItems.length) refreshNavItems();
      setActiveIndex(navIndex === -1 ? navItems.length - 1 : navIndex - 1);
      return;
    }

    if (e.key === "Enter") {
      // Enter should open highlighted item if exists, else do normal search
      e.preventDefault();
      openActiveOrSearch();
      return;
    }
  });

  input.addEventListener("input", () => {
    clearTimeout(debounceTimer);
    navIndex = -1;
    clearKbActive();

    const q = input.value.trim();

    if (!q) {
      renderTrending();
      return;
    }

    results.innerHTML = `<div class="masha-search-hint">Searching…</div>`;
    refreshNavItems();

    debounceTimer = setTimeout(async () => {
      try {
        const url =
          `/search/suggest.json?q=${encodeURIComponent(q)}` +
          `&resources[type]=product` +
          `&resources[limit]=9` +
          `&resources[options][unavailable_products]=last`;

        const res = await fetch(url, { headers: { Accept: "application/json" } });
        const data = await res.json();

        const products = data?.resources?.results?.products || [];
        const queries = data?.resources?.results?.queries || [];

        const suggestionsHTML = `
          <div class="masha-suggestions">
            <div class="masha-suggestions__title">Suggestions</div>
            <div class="masha-suggestions__list">
              ${
                queries.slice(0, 7).map((x) => `
                  <a class="masha-suggestion" href="/search?q=${encodeURIComponent(x.text)}">${x.text}</a>
                `).join("") || `<div class="masha-search-hint">No suggestions yet.</div>`
              }
            </div>
          </div>
        `;

        const productsHTML = `
          <div class="masha-products">
            <div class="masha-products__title">Products</div>
            <div class="masha-products__grid">
              ${
                products.map((p) => `
                  <a class="masha-product" href="${p.url}">
                    <div class="masha-product__img">
                      <img src="${safeImg(p)}" alt="${(p.title || "").replace(/"/g, "&quot;")}" loading="lazy">
                    </div>
                    <div class="masha-product__body">
                      <div class="masha-product__title">${p.title || ""}</div>
                      <div class="masha-product__price">${moneyFromCents(p.price)}</div>
                    </div>
                  </a>
                `).join("") || `<div class="masha-search-hint">No products found.</div>`
              }
            </div>
          </div>
        `;

        results.innerHTML = suggestionsHTML + productsHTML;
        refreshNavItems();
      } catch (err) {
        results.innerHTML = `<div class="masha-search-hint">Couldn’t load results. Try again.</div>`;
        refreshNavItems();
      }
    }, 160);
  });

  // If pane was accidentally visible on load, normalize it
  if (pane.getAttribute("aria-hidden") === "false") {
    openPaneFresh();
  }
})();